import { Scanner, ScannerListenerReturnType, ScannerListenerType, ScannerOptions } from '.'
import { Device } from '@capacitor/device'

const DEFAULT_PARSERS = {
  listener: {
    success: (e:Datalogic.BarcodeResult) => ({data: e?.barcodeData, type: e?.barcodeType}),
    error: e => e
  }
}

export default class Datalogic<CB = any, SR extends ScannerListenerReturnType = ScannerListenerReturnType> implements Scanner {
  listeners: Map<string, any>
  options: ScannerOptions

  constructor (options?: ScannerOptions) {
    this.listeners = new Map()
    this.options = options || {}
  }

  supported ():Promise<boolean> {
    return new Promise((resolve) => {
      try {
        // checks if the datalogic api support (i.e a datalogic scanner) by checking if scannerProperties returns support for (some) essential code-types
        scannerProperties.edit(json => {
          const data = typeof json === 'string' ? JSON.parse(json) : json
          const deviceSupported = ['ean8', 'ean13', 'datamatrix', 'upcE', 'upcA', 'gs1DataBar_14', 'gs1DataBar_Expanded', 'gs1DataBar_Limited', 'interleaved25', 'datamatrix']
            .every(s => data[s] && data[s].supported === true)

          resolve(deviceSupported)
        }, e => { console.log('Datalogic.supported.scannerProperties', e); resolve(false) })
      } catch (e) {
        resolve(false)
      }
    })
  }

  listen<T extends ScannerListenerType = ScannerListenerType> (type: T, success: (data:SR[T]) => void = data => data, error: (error) => void = e => console.error(e)): Datalogic.GenericCallbackFn<string> | undefined {
    try {
      if (!barcodeManager) {
        return
      }
      return barcodeManager.addReadListner(
        (e: string) => {
          try {
            const d = JSON.parse(e)
            success({ data: d.barcodeData, type: d.barcodeType})
          } catch (e) {
            console.error('Error during listener success calback', e)
            error(e)
          }
        },
        e => error(e))
    } catch (e) {
      if (e instanceof ReferenceError && e.message?.includes('barcodeManager')) console.warn(`Tried to listen for ${type} events but barcodeManager (global scope) is not defined`)
      else console.error(e)
    }
  }

  mute (type: string) {
    // unexposed on barcodeManager, but internally implemented in onPause
  }

  destroy (id?: string | undefined): void {
    //
  }
}
